import type { App } from "vue"
import WTCard from "@/components/WTCard/index.vue"
import WCloseTag from "@/components/WCloseTag/index.vue"
import WElCard from "@/components/WElCard/index.vue"

const components = [WTCard, WCloseTag, WElCard]

export function useLocalCpn(app: App) {
  // 全局注册本地组件
  components.forEach((component: Component) => {
    app.component(component.name, component)
  })
}
